import { useProduct } from 'components/products/context';
import styles from 'styles/shop/product.module.css';
import { Clickable } from 'phoenix-components';
import cx from 'classnames';
import { useLanguageLoader } from 'contexts/language';
import { useField } from 'formik';
import { useSelectedVariant } from 'components/products/hooks';

export function VariantBox() {
  const product = useProduct();
  const [, , { setValue: setVariant }] = useField('variantId');

  const {
    variants = [],
    multiVariant = false
  } = product;

  const lang = useLanguageLoader();
  const selectedVariant = useSelectedVariant();

  if (!multiVariant) {
    return null;
  }

  return (
    <div>
      {variants.length > 0 && (
        <>
          <div className={styles.key}>
            {variants[0]?.info?.name === 'Size'
              ? lang('store.words.availableSizes')
              : `${lang('store.words.select')} ${variants[0]?.info?.name}`}
          </div>
          <div className={styles.flex}>
            {variants.map((x) => (
              <Clickable
                key={x._id}
                className={cx(styles.btn, styles.variant, {
                  [styles.selected]: selectedVariant?._id === x._id
                })}
                onClick={() => {
                  setVariant(x?._id);
                }}
              >
                {x?.info?.value}
              </Clickable>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
